import { Helmet } from 'react-helmet';
import LeftBar from '../components/common/NavBar';
import NewHeaderComponent from '../components/common/NewHeaderComponent';
import { isDoctor, openCrispChat } from './utils';
import { useEffect, useState } from 'react';
import TrialOrderSelectionModal from '../components/TrialOrderSelectionModal';
import { settingsIcon2 } from '../components/common/Icons';
import { AntTooltip } from '../components/common/AntTooltip';
import { useHistory } from 'react-router-dom';
import { GO_TO_HE_ONBOARDING } from '../routes/paths';
import { track } from '../tracking';

const NewHXNGFlow: React.FC = () => {
    const [isTrialOrderModalVisible, setIsTrialOrderModalVisible] = useState(false);
    const history = useHistory();

    const onTalkToUs = () => {
        openCrispChat(
            'NEED_HELP_HXNG',
            {
                from: 'New HXNG Flow',
            },
            `I want to know more around in-clinic commerce.`,
        );
    };

    const toggleIsTrialOrderModalVisible = () => {
        setIsTrialOrderModalVisible(!isTrialOrderModalVisible);
    };

    useEffect(() => {
        window.addEventListener('message', handlePostMessage);
        return () => window.removeEventListener('message', handlePostMessage);
    }, []);

    const handlePostMessage: EventListener = (e) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const type = e?.data?.type;
        switch (type) {
            case 'PLACE_FREE_TRIAL_ORDER':
                toggleIsTrialOrderModalVisible();
                break;
            case 'TALK_TO_US':
                onTalkToUs();
                break;
        }
    };

    const onSettings = (): void => {
        history.replace(GO_TO_HE_ONBOARDING('home'));
        track('NEW_HXNG_FLOW_ON_SETTINGS');
    };

    return (
        <div className="flex flex-col w-full h-full bg-white font-lato">
            <Helmet>
                <meta charSet="utf-8" />
                <title>EKA - New Health Exchange Flow</title>
            </Helmet>

            <div className="grid h-full overflow-x-auto overflow-y-hidden grid-cols-queueGrid min-w-840 undefined">
                <LeftBar />
                <div className="flex flex-col h-full col-span-11 overflow-hidden">
                    <NewHeaderComponent
                        title="Clinic Commerce"
                        filterComponent={
                            <div className="flex w-full justify-end items-stretch gap-8">
                                <div className="flex gap-8 h-36 items-stretch">
                                    <AntTooltip content="Onboard in Clinic Commerce">
                                        {isDoctor() && (
                                            <button
                                                className="bg-darwin-neutral_new-50 w-36 p-6 cursor-pointer flex items-center gap-8 text-neutral-black font-400 text-13 justify-center px-12 py-4 rounded-8"
                                                onClick={onSettings}
                                            >
                                                {settingsIcon2('w-17 flex-shrink-0')}
                                            </button>
                                        )}
                                    </AntTooltip>
                                </div>
                            </div>
                        }
                    />
                    <div className="flex-1">
                        <iframe
                            className="w-full h-full"
                            src="https://product.eka.care/iframes/clinic-commerce"
                        />
                    </div>
                </div>
            </div>
            <TrialOrderSelectionModal
                isVisible={isTrialOrderModalVisible}
                closeMe={toggleIsTrialOrderModalVisible}
                from={'new hxng page'}
            />
        </div>
    );
};

export default NewHXNGFlow;
